var map = {
	"./act": 1565,
	"./act.ts": 1565,
	"./gmat": 1566,
	"./gmat.ts": 1566,
	"./gre": 1567,
	"./gre.ts": 1567,
	"./ielts": 1568,
	"./ielts.ts": 1568,
	"./ielts_general_training": 1569,
	"./ielts_general_training.ts": 1569,
	"./lsat": 1570,
	"./lsat.ts": 1570,
	"./mcat": 1571,
	"./mcat.ts": 1571,
	"./sat": 1572,
	"./sat.ts": 1572,
	"./toefl": 1573,
	"./toefl.ts": 1573
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2621;
module.exports = webpackAsyncContext;